import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(Router);
const router = new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths
});
// router gards
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register', '/recover_password'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('default_auth_token');

  if (authRequired && !loggedIn) {
    return next('/login');
  }
  NProgress.start();
  next();
});

router.afterEach((to, from) => {
  // ...
  NProgress.done();
});

Vue.use(VueAxios, axios);
axios.defaults.baseURL = '/api';
Vue.mixin({
  data: function () {
    return {
      get BaseUrl () {
        return axios.defaults.baseURL;
      }
    };
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js